import type { PlayerProfile } from '~/types/player-profile';
import { normalizePlayerVip } from '~/utils/apostatudo/player-vip';

// Contrato do core (snake_case, sem envelope `data` — `$wrap = null` no
// PlayerProfileResource). Três campos, é tudo:
// { user_id, is_eligible, vip: null | { tag, order, color } }
type RawProfile = {
  user_id?: unknown;
  is_eligible?: unknown;
  vip?: unknown;
};

// Elegibilidade só é `true` quando o core AFIRMA `true`. Campo ausente, tipo
// inesperado ou payload truncado é "não" — a mesma regra do board, pra um erro
// de contrato nunca virar convite pra uma promoção que o jogador não tem.
export function mapPlayerProfile(
  raw: RawProfile,
  userId: number,
): PlayerProfile {
  return {
    userId: typeof raw.user_id === 'number' ? raw.user_id : userId,
    isEligible: raw.is_eligible === true,
    // A normalização do `vip` mora num util porque o memo desta aba lê o MESMO
    // formato e também não pode confiar nele — ver utils/apostatudo/player-vip.
    vip: normalizePlayerVip(raw.vip),
  };
}
